import { useRef, useState, useEffect } from 'react'
import { intersection_threshold, url } from '../../base/Variables'
import { catchError, slugify, LazyAxios } from '../../base'
import { ProductCard, ProductPlaceholder } from '../index'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function ShopRelatedProduct({ type, shop_id, setPerror, setShopDetail, shopDetail }) {
  const [loading, setLoading] = useState(true)
  const [products, setProducts] = useState(null)
  const componentRef = useRef(null)
  const navigate = useNavigate()
  const cart_item_list = useSelector((state) => state.cartSlice.cart_item_list)


  async function getShopRelatedProduct() {
    try {
      const axios = await LazyAxios()
      const request = await axios.get(`${url}/api/v1/shop/${shop_id}/${type}/`)
      console.log(request.data)
      if (request.data && request.data.data) {
        setProducts(request.data.data)
      }
      else if (request.data && request.data.shop === null) {
        setShopDetail && setShopDetail(null)
      }
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      setPerror(catchError(error).error_message)
      setLoading(false)
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Check if the child component is in the viewport
        if (entries[0].isIntersecting && loading) {
          // Trigger the API call or any function passed as prop
          if (shop_id) {
            getShopRelatedProduct()
          }
          else {
            setLoading(false)
          }
        }
      },
      {
        root: null, // default to the viewport
        threshold: intersection_threshold, // 40% of the component must be visible
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [shop_id, loading])

  console.log(cart_item_list)
  return (
    <div className='mt-4' ref={componentRef} >
      {
        loading ? <ProductPlaceholder /> :
          products &&
          <>
            <div className='h5 mb-3'>{type === 'getShopTopDiscountProduct' ? 'Top Discount Products' : 'Top Selling Products'}</div>
            <div style={{ display: 'flex', gap: '30px', width: '100%', overflowX: 'scroll', scrollbarWidth: 'none' }}>
              {
                products.map((item, index) => {
                  return <div key={index}>
                    <ProductCard setPerror={setPerror} product={item} added={cart_item_list[`p${item.id}`] ? true : false} />
                  </div>
                })
              }
            </div>
            <div className='text-center'>
              <button onClick={() => navigate(`/p/shop/${slugify(shopDetail.shop_name)}/category/all/products/?${type === 'getShopTopDiscountProduct' ? 's_b=ds-hl' : 's_b=u-s'}`)} className='primaryButton'>See all</button>
            </div>
            <hr className='mt-5' />
          </>
      }
    </div>
  )
}

export default ShopRelatedProduct